<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center">
      <b-col md="7" class="mt-3">
        <b-card-group>
          <b-card id="auftrag1" ref="el">
            <div slot="header"
                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              <b-row style="margin-left: 0px; margin-right: 0px">
                <div>
                  Tour
                </div>
                <b-col></b-col>
                <div>
                  Begin: <strong>{{formateAnlageDate}}</strong>
                </div>
              </b-row>
            </div>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span>Tourname</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="auftrag.gi_auf_ext"
                              disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2">
                <span>Hinweis</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    disabled
                    type="text"
                    v-model="auftrag.gi_memo"
                    :placeholder="auftrag.gi_memo"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span>Ausgeführt von:</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAhnehmerUser"
                              disabled></b-form-input>
              </b-col>
            </b-row>
          </b-card>
        </b-card-group>

        <b-card class="mt-2">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Touraufgaben:</strong>
            </b-col>
            <b-col>
            </b-col>
          </b-row>
          <b-row style="margin-top: -1.25rem">
            <b-col style="padding: 0px">
              <tour-table ref="auftraegeTable"
                          :table-data="tourTasks"
              ></tour-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="5" class="mt-3">
        <b-card class="mb-2">
          <b-row style="gap: 10px">
            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
              Zurück
            </b-button>
          </b-row>
        </b-card>
        <b-card v-if="resultingTourTasks.length > 0" class="mb-2">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Aufgaben aus der Tour</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm"
                          @click="createSubTour" :disabled="!hasInside">
                  Vergeben
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin: -18px" v-if="resultingTourTasks.length > 0">
            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container2"
                   ref="map_container2">
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mt-2 mb-2" v-if="tourTraces != null && tourTraces.length">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Nachweise:</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped bordered hover responsive :items="tourTraces"
                       :fields="traceFields">
                <template v-slot:cell(actions)="row">
                  <b-button variant="success"  class="font-sm" v-on:click="$refs.trace_map.showMap(allTraces[row.item.trace_id], tourTasks)">
                    Anzeigen
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
    <select-legr-dialog ref="select_legr" @legr-selected="(legr) => {$refs.accept_dialog.onSetLegr(legr)}"></select-legr-dialog>
    <accept-task-dialog ref="accept_dialog" create-sub-tour :bauhof-structure="bauhofStructure" :auftrag="subTour" :augr-name="augrName"
                        @select-legr="$refs.select_legr.showDialog()"
                        @select-planning="(users) => {$refs.select_plannings.showDialog(users)}"
                        @change-planning="(currentPlanning) => {fromAccept = true; $refs.change_todo.showDialog(currentPlanning)}"
                        @accept-task="onSubTourCreated"
    ></accept-task-dialog>
    <select-planning-dialog ref="select_plannings" @planning-selected="(plannings) => {$refs.accept_dialog.onNewPlanning(plannings)}"></select-planning-dialog>
    <trace-map ref="trace_map"></trace-map>

  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {
  arrayBufferToBase64,
  decryptAES,
  decryptFile,
  decryptMessages,
  decryptTodos,
  encryptAES,
  encryptFile, encryptMultipleAES,
  encryptServerTodos, encryptTodos
} from "../../../shared/crypto";
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import AccountBox from 'vue-material-design-icons/AccountBox.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import {Redirect_500, Server_URL} from "@/shared/utils";
import TaskMessaging from "../../messaging/task_messaging.vue"
import TaskMessagingFooter from "@/views/messaging/task_messaging_footer.vue";
import TaskMessagingUsers from "@/views/messaging/task_messaging_user.vue";
import TaskMessagingInvite from "@/views/messaging/task_messaging_invite.vue";
import ForwardMessaging from "@/views/messaging/forward_messaging.vue";
import TaskForwardMessaging from "@/views/messaging/task_forward_messaging.vue";
import ForwardsDialog from "@/views/messaging/task_messaging_forwards_dialog.vue";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import VJstree from 'vue-jstree'
import UpdateTodosDialog from "@/views/aufgaben_verwaltung/UpdateTodosDialog.vue";
import ChangeTodoDialog from "../../aufgaben_verwaltung/ChangeTodoDialog.vue"
import FinishTaskDialog from "../../aufgaben_verwaltung/FinishTaskDialog.vue"
import TraceMap from "../../aufgaben_verwaltung/TraceMap.vue"
import AGeberDialog from "../../aufgaben_verwaltung/AGeberDialog.vue"
import TaskShare from "@/views/messaging/task_messaging_share.vue";
import TaskShareFooter from "@/views/messaging/task_forwards_footer.vue";
import TaskMessagingButton from "@/views/messaging/task_messaging_button.vue";

import SelectLegrDialog from "../../aufgaben_verwaltung/SelectLegrDialog.vue"
import AcceptTaskDialog from "../../aufgaben_verwaltung/AcceptTaskDialog.vue"
import SelectPlanningDialog from "../../aufgaben_verwaltung/SelectPlanningDialog.vue"


import FinishIcon from 'vue-material-design-icons/CheckCircle.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';




import { doc, onSnapshot } from "firebase/firestore";
import {firestoreDb} from "@/shared/firebase";
import {listenMessageCounter, PARTICIPANT_PATH} from "@/shared/firebase/database";
import CreateTaskSeriesDialog from "@/views/aufgaben_verwaltung/CreateTaskSeriesDialog.vue";
import TourTable from "@/views/auftraege/auftrag/TourTableLight.vue";
import TaskLocationMap from "@/views/auftraege/auftrag/TaskLocationMap.vue";
import TaskAttachmentUpload from "@/views/auftraege/auftrag/TaskAttachmentUpload.vue";

import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
require('../../../shared/free_draw');


export default {
  name: "auftrag",
  components: {
    TaskAttachmentUpload,
    TaskLocationMap,
    TourTable,
    CreateTaskSeriesDialog,
    AccountMultiplePlusIcon,
    AccountBox,
    TaskMessaging,
    TaskMessagingFooter,
    TaskMessagingUsers,
    TaskMessagingInvite,
    BookOpenPageVariantIcon,
    CheckBoldIcon,
    VJstree,
    UpdateTodosDialog,
    ChangeTodoDialog,
    FinishTaskDialog,
    TaskShare,
    ForwardsDialog,
    ForwardMessaging,
    AGeberDialog,
    TaskForwardMessaging,
    TaskShareFooter,
    TaskMessagingButton,
    FinishIcon,
    DeleteIcon,
    SelectLegrDialog,
    AcceptTaskDialog,
    SelectPlanningDialog,
    TraceMap
  },
  computed: {
    formateDate() {
      if (this.auftrag.datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateAnlageDate() {
      if (this.auftrag.datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateFertig() {
      if (this.auftrag.fertig_datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.fertig_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateAugr() {
      return this.auftrag.gi_augr + " " + this.augrName;
    },
    formateAhnehmerUser() {
      if (this.auftrag.a_nehmer_user === "" || this.auftrag.a_nehmer_user === "auto") {
        return "Automatische Annahme";
      } else {
        let res = JSON.parse(sessionStorage.getItem(this.auftrag.a_nehmer_user));
        if (res === null) {
          return this.auftrag.a_nehmer_user;
        }
        return res.first_name + " " + res.surname;
      }
    }
  },
  props:{
    onFileClicked: {
      type: Function,
      default: undefined
    },
    onFileOk: {
      type: Function,
      default: undefined
    },
    onAttachment: {
      type: Function,
      default: undefined
    },
    responseError: {
      type: Function,
      default: undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    showFinish: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      canHandle: false,
      kostMigrs: [],
      selectedKostMigr: null,
      showChangeKostMigr: false,
      bauhofStructure: [],
      auftrag: {
        id: "testid",
        a_nehmer: "Bauhof",
        auftraggeber: "Musterhausen-Public Solutions",
        ziel: "26.01.2019",
        ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
        gi_hh_aus: "9300300.55511010.2-85500",
        beleg_ex: "2019-0001",
        gi_auf_ext: "Test Sven",
        gi_match: "Forstwirtschaft",
        gi_augr: "0009",
        gi_aufisn: "000038",
        gi_memo: "Test vom Sven",
        email: "info@publicsolutions.de",
        datum: "",
        sachbearbeiter: "Administrator",
        offen: 0,
        quittung: null
      },
      augrName: "",
      deleteMessage: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      maxrows: 40,
      textBackup: undefined,
      dateBackup: undefined,
      aufExtBackup: undefined,
      massnahmeBackup: undefined,
      materialBackup: undefined,
      ausfuhrTypeBackup: undefined,
      ausfuhrBackup: undefined,
      delete_modal: false,
      freigabe: false,
      deletable: false,
      userId: "",

      // chat specific
      hasChat: false,
      url: "",
      download: "",
      filename: "",
      a_nehmer: "Bauhof",
      hasContact: false,
      contact: "",
      canFinish: false,
      todos: [],
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      hintFields: [
        {key: 'create_date', label:"Datum", formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return event.toLocaleDateString('de-DE', options);
          }},
        {key: 'user_id', label:"Meldung von"},
        {key: 'message', label:"Nachricht"},
      ],
      todoFields: [
        {key: 'is_finished', label: 'Status'},
        {key: 'user_id', label:"Zuweisung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (item.name !== "") {
              return item.name;
            }
            let res = JSON.parse(sessionStorage.getItem(item.user_id));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'till', label:"Termin", formatter: 'dateToString'},
        {key: 'message', label: "Aufgabenbeschreibung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = item.message;
            let n = 50;
            return (res.length > n) ? res.slice(0, n-1) + '...' : res;
          }},
        {key: 'hint', label: 'Hinweise'}
      ],
      traceFields: [
        {key: 'start', label:"Datum", formatter: 'dateToString'},
        {key: 'mita', label:"Mitarbeiter", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = JSON.parse(sessionStorage.getItem(item.mita));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'end', label: "Dauer", formatter: (value, key, item) => {
            let start = new Date(item.start.replace('Z',''));
            let end = new Date(item.end.replace('Z',''));
            let duration = (end.getTime() - start.getTime()) / 60000;
            let hours = Math.floor(duration / 60);
            let minutes = Math.floor(duration%60);
            return hours + "," + minutes.toString().padStart(2, '0') + " Stunden";
          }},
        {key: 'actions', label: ''}
      ],
      canShare: false,
      showShare: false,
      taskShort: {
        id: "",
        title: "",
        description:"",
        where:"",
        from:"",
        till:"",
      },
      currentHints: [],
      showHintPopup: false,
      forwards: [],
      openForwards: false,
      forwardRoom: null,
      addressData: {
        gi_anrede: '',
        gi_name1: '',
        gi_name2: '',
        gi_strasse: '',
        gi_plz: '',
        gi_ort: '',

        re_anrede: '',
        renr: '',
        re_vorname: '',
        re_name1: '',
        re_str_hnr: '',
        re_land: '',
        re_plz: '',
        re_ort: '',
      },
      einzel: null,
      taskId: "",
      tourTasks: [],
      hasSelects: false,
      isBauhof: false,
      geoRefPerimeter: "",
      files: [],
      hasTaskSeries: false,
      resultingTourTasks: [],
      hasInside: false,
      insideTourTasks: [],
      taskPredef: null,
      fromAccept: false,
      subTour: {
        gi_auf_ext: "",
      },
      tourTraces: [],
      allTraces: {},
    }
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
  },
  beforeDestroy: function () {
    for (const property in this.listeners) {
      this.listeners[property].forEach(listener => listener())
      this.listeners[property] = []
    }
  },
  methods: {
    onSubTourCreated(req) {
      req.gi_aufisn = this.insideTourTasks[0].aufisn;
      req.resulting_tour_tasks = this.insideTourTasks;
      this.showLoader();
      encryptMultipleAES(sessionStorage.getItem("aes"), [req.gi_memo]).then(res => {
        req.gi_memo = res[0];
        req.key = sessionStorage.getItem("aes");
        if (req.todos && req.todos.length) {
          encryptTodos(sessionStorage.getItem("aes"), req.todos).then(res => {
            req.todos = res;
            this.$http.post(
                Server_URL+'/auftragsbuch/data/plan_resulting_tour_tasks/' + this.auftrag.id,
                req,
            ).then(this.responseOkReload, this.responseError)
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.$http.post(
              Server_URL+'/auftragsbuch/data/plan_resulting_tour_tasks/' + this.auftrag.id,
              req,
          ).then(this.responseOkReload, this.responseError);
        }
      }).catch(res => {
        console.log(res);
      })
    },
    createSubTour() {
      this.subTour.gi_auf_ext = this.taskPredef.resulting_task_name;
      this.$refs.accept_dialog.showDialog(null, false);
    },
    responseUploadOk(response) {
      if (response.status === 200 && response.body.status === "ok") {
        if (this.files.length === 0) {
          this.responseOkReload()
        } else {
          this.uploadFile();
        }
      } else {
        window.location = Redirect_500;
      }
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },

    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    async responseOkFetch(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.userId = response.body.session.id;
        let data = response.body.data;
        this.canShare = false;
        await this.decryptTourData(data.general_tour_tasks);
        if (sessionStorage.getItem("aes") !== null) {
          this.decryptData(data.data.gi_memo, data.data.notiz_annahme,
              data.data.notiz_fertig).then(res => {
            data.data.gi_memo = res[0];
            data.data.notiz_annahme = res[1];
            data.data.notiz_fertig = res[2];
            this.setData(data);
          }).catch(e => {
            this.setData(data);
          });
        } else {
          this.setData(data);
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptTourData(data) {
      if (data === null || data === undefined) {
        return;
      }
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i].selected = false;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.tourTasks = data;
      /*this.$refs.auftraegeTable.allSelected = false;
      this.$refs.auftraegeTable.indeterminate = false;
      this.hasSelects = false;*/
    },
    async decryptData(memo, annahme, fertig) {
      try {
        if (memo !== null && memo !== "") {
          memo = await decryptAES(sessionStorage.getItem("aes"), memo);
        }
      } catch (e) {
      }
      try {
        if (annahme !== null && annahme !== "") {
          annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
        }
      } catch (e) {
      }
      try {
        if (fertig !== null && fertig !== "") {
          fertig = await decryptAES(sessionStorage.getItem("aes"), fertig);
        }
      } catch (e) {
      }
      return [memo, annahme, fertig]
    },
    setData(data) {
      this.auftrag = data.data;
      if (data.resulting_task_tour_tasks) {
        this.resultingTourTasks = data.resulting_task_tour_tasks;
      }
      this.taskPredef = data.task_predef;
      this.tourTraces = data.traces;
      this.allTraces = data.trace_map;
      this.geoRefPerimeter = data.geo_ref_perimeter;
      this.augrName = data.augr_name;
      this.allGroups = data.all_groups;
      this.bauhofStructure = data.bauhof_structure;
      this.kostMigrs = this.computeKostMigrs(JSON.parse(JSON.stringify(data.bauhof_structure)));
      this.hideLoader();
      this.canHandle = data.can_handle;
      this.editMode = false;
      this.canFinish = true;


      let res = JSON.parse(sessionStorage.getItem(this.auftrag.sachbearbeiter));
      if (res !== null) {
        this.auftrag.sachbearbeiter = res.first_name + " " + res.surname;
        this.auftrag.email = res.email;
      }
      this.$nextTick(() => {
        this.showTourTasksMapIfNeeded();
      });

      this.hasChat = false;
    },
    back() {
      window.history.back();
    },
    responseErrorTrap(response) {
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseOkReload() {
      this.$http.get(
          Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
      ).then(this.responseOkFetch, this.responseError)
    },

    showTourTasksMapIfNeeded() {
      if (this.resultingTourTasks.length === 0 || this.map2 !== undefined ) {
        return;
      }
      let bounds = new (mapboxgl.LngLatBounds);
      for (let i = 0; i < this.resultingTourTasks.length; i++) {
        if (this.resultingTourTasks[i].lat === 0 || this.resultingTourTasks[i].lon === 0) {
          continue;
        }
        bounds.extend(new mapboxgl.LngLat(this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat));
      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map2 = new mapboxgl.Map({
        container: 'map_container2',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        bounds: bounds,
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });
      this.map2.addControl(this.draw, 'top-left');
      this.map2.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map2.addControl(languageControl);
      this.markers = null;
      this.geojson = {};
      this.map2.on('load', this.mapLoad2);
    },
    onAreaUpdated(e) {
      let polygons = this.draw.getAll();
      this.hasInside = false;
      this.insideTourTasks = [];
      if (polygons.length === 0) {
        this.drawMarkers();
      } else {
        this.removeMarkers();
        for (let i = 0; i < this.resultingTourTasks.length; i++) {
          let isInside = false;
          for (let j = 0; j < polygons.features.length; j++) {
            if (booleanPointInPolygon([this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat], polygons.features[j])) {
              isInside = true;
              this.hasInside = true;
              this.insideTourTasks.push(this.resultingTourTasks[i]);
              break;
            }
          }
          let el = document.createElement('div');
          el.className = isInside ? 'marker_selected' : 'marker';
          el.id = this.resultingTourTasks[i].id;


          let marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat])
              .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(
                  this.resultingTourTasks[i].name
              ))
              .addTo(this.map2);
          marker.id = this.resultingTourTasks[i].id;
          marker.isSelected = isInside;
          this.markers.push(marker);
        }
      }
    },
    removeMarkers() {
      if (this.markers === null || this.markers.length === 0) {
        this.markers = [];
        return;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].remove();
      }
      this.markers = [];
    },
    drawMarkers() {
      this.removeMarkers()
      for (let i = 0; i < this.resultingTourTasks.length; i++) {
        let el = document.createElement('div');
        el.className = 'marker';
        el.id = this.resultingTourTasks[i].id;
        //el.addEventListener('click', this.onMarkerClicked);

        let marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([this.resultingTourTasks[i].lon, this.resultingTourTasks[i].lat])
            .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(
                this.resultingTourTasks[i].name
            ))
            .addTo(this.map2);
        marker.id = this.resultingTourTasks[i].id;
        this.markers.push(marker);
      }
    },
    mapLoad2() {
      setTimeout(() => {
        if (this.markers === null) {
          this.onAreaUpdated();
          this.map2.on('draw.create', this.onAreaUpdated);
          this.map2.on('draw.delete', this.onAreaUpdated);
          this.map2.on('draw.update', this.onAreaUpdated);
        }
        this.map2.resize();
      });
    },
  }
}
</script>

<style>

.marker {
  background-image: url('../../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}
.marker_selected {
  background-image: url('../../../../public/marker_selected.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.sc-message {
  width: 480px;
}

.sc-message--text .sc-message--toolbox {
  display: none;
}

.sc-launcher.opened :before {
  box-shadow: none;
}

.sc-launcher.opened:before {
  box-shadow: none !important;
}

.sc-chat-window {
  border: 1px solid lightgray !important;
  width: 520px !important;
  z-index: 5;
}

.sc-launcher {
  z-index: 5;
}

.sc-header {
  min-height: unset !important;
}

.sc-user-input {
  border-top: 1px solid lightgray !important;

}

.sc-user-input--text {
  width: 450px !important;
}

.sc-header--close-button {
  margin-left: 0 !important;
}

.my-body {
  padding: 0 !important;
}

.hidden_header {
  display: none;
}

.sc-user-input--file-icon-wrapper {
  margin-bottom: 0;
}
</style>

<style scoped>

.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.p-center {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
}

.bold-text {
  font-weight: bold;
}

::placeholder { /* Firefox, Chrome, Opera */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}

.icon-muted {
  cursor: initial !important;
  opacity: 0.3 !important;
}

</style>
